import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

const statusFilter = ({ source, initialFilterValues, clearQuickFilters }: BaseFilterProps) => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.draft'),
      value: 'draft',
    },
    {
      label: i18n.t('expenses_v2.list.filters.reversed'),
      value: 'reversed',
    },
    {
      label: i18n.t('expenses_v2.list.filters.pending'),
      value: 'pending',
    },
    {
      label: i18n.t('expenses_v2.list.filters.approved'),
      value: 'approved',
    },
    {
      label: i18n.t('expenses_v2.list.filters.rejected'),
      value: 'rejected',
    },
    {
      label: i18n.t('expenses_v2.list.filters.in_payroll'),
      value: 'in_payroll',
    },
    {
      label: i18n.t('expenses_v2.list.filters.sent_to_pay'),
      value: 'sent_to_pay',
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      value: 'paid',
    },
  ]

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: initialFilterValues.status ? [initialFilterValues.status] : [],
      },
    ],
    onUpdateValue: () => {
      clearQuickFilters?.()
    },
    identifier: 'expensesList.statusFilter',
    path: 'status',
    title: i18n.t('expenses_v2.list.header.status'),
    default: !!initialFilterValues.status,
  })
}

export default statusFilter
